import { render, staticRenderFns } from "./ProfilePicFrames.vue?vue&type=template&id=0e5cbf7e&scoped=true&"
import script from "./ProfilePicFrames.vue?vue&type=script&lang=js&"
export * from "./ProfilePicFrames.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePicFrames.vue?vue&type=style&index=0&id=0e5cbf7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5cbf7e",
  null
  
)

export default component.exports